<template>
  <b-card class="sticky-sidebar mt-lg-0 mb-3 px-0">
    <div class="d-none d-flex">
      <div
        v-if="loading"
        class="d-flex justify-content-center flex-column align-items-center w-100"
      >
        <b-skeleton width="200px" height="30px" class="my-1" />
        <b-skeleton width="200px" height="30px" class="my-1" />
        <b-skeleton width="200px" height="30px" class="my-1" />
      </div>
      <div
        v-else-if="!semester.bought"
        :class="[
          'w-100',
          { 'buy-section': !semester.bought && semester.can_buy },
        ]"
      >
        <div
          class="w-100"
          v-show="
            !semester.bought &&
            !semester.can_buy &&
            !availableAtTimer
          "
        >
          <b-badge
            variant="light-warning"
            class="w-100 font-weight-bolder p-75"
          >
            <h6 class="text-warning mb-0">مهلت ثبت نام به پایان رسیده است</h6>
          </b-badge>
        </div>
        <h4
          class="d-flex justify-content-center my-1"
          v-if="!semester.bought && semester.can_buy"
        >
          <span
            class="text-danger"
            v-if="finalAmount != semester.amount"
            style="text-decoration: line-through"
          >
            {{ numberWithCommas(semester.amount) }}
          </span>
          <span class="text-success"
            >{{ numberWithCommas(finalAmount) }} تومان</span
          >
        </h4>
        <div class="d-lg-block d-none">
          <div
            v-show="
              !semester.bought &&
              semester.can_buy &&
              availableAtTimer
            "
          >
            <div
              class="d-flex justify-content-center align-items-center flex-wrap text-info my-1 font-weight-bold"
            >
              <div class="my-1">زمان باقی مانده تا شروع ثبت نام :</div>
              <timer
                class="flex-row"
                color="info"
                :time="semester.available_at"
                v-model="availableAtTimer"
              />
            </div>
          </div>
          <div
            v-show="
              !semester.bought &&
              semester.can_buy &&
              !availableAtTimer &&
              unavailableAtTimer
            "
          >
            <div
              class="d-flex justify-content-center align-items-center flex-wrap my-1 font-weight-bold text-danger"
            >
              <div class="my-1">زمان باقی مانده تا پایان مهلت ثبت نام :</div>
              <timer
                class="flex-row"
                color="danger"
                :time="semester.unavailable_at"
                v-model="unavailableAtTimer"
              />
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-center w-100"
          v-if="!semester.bought && semester.can_buy"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="success"
            class="d-lg-none px-5 d-flex"
            @click="checkout"
          >
            خرید ترم
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="success"
            block
            class="mb-75 d-lg-block d-none"
            @click="checkout"
          >
            خرید ترم
          </b-button>
        </div>
        <b-button
          :to="{ name: 'semesters' }"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          class="mt-75"
          block
          v-if="
            Object.keys(userData).length &&
            userData.permissions &&
            userData.permissions.permissions &&
            userData.permissions.permissions.length
          "
        >
          برگشت به لیست ترم ها
        </b-button>
        <hr class="my-2" v-if="!semester.bought" />
      </div>
      <div class="w-100" v-else>
        <b-badge variant="light-success" class="w-100 font-weight-bolder p-1">
          <h6 class="text-success mb-0">شما دانشجوی این ترم هستید</h6>
        </b-badge>
      </div>
    </div>
    <div
      v-if="loading"
      class="d-flex justify-content-center flex-column align-items-center"
    >
      <b-skeleton width="100%" height="50px" class="my-1" />
      <b-skeleton width="100%" height="50px" class="my-1" />
      <b-skeleton width="100%" height="50px" class="my-1" />
    </div>
    <template v-else-if="roadmaps.length">
      <h4 class="my-2">نقشه راه ترم</h4>
      <app-timeline>
        <app-timeline-item
          :num="index + 1"
          v-for="(roadmap, index) in roadmaps"
          :key="index"
        >
          <b-link
            :to="{
              name:
                roadmap.item_type && roadmap.item_type == 'event'
                  ? 'show-event'
                  : 'show-course',
              params: { id: roadmap.id },
            }"
          >
            <div
              class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0 px-md-0 px-2"
            >
              <h6>{{ roadmap.name || roadmap.title }}</h6>
              <small class="text-muted" v-if="roadmap.duration">
                طول دوره : {{ roadmap.duration }}
              </small>
              <small class="text-muted">
                {{
                  roadmap.available_at
                    ? calcDate(roadmap.available_at)
                    : calcDate(roadmap.started_at)
                }}</small
              >
            </div>
            <div
              class="text-muted mt-1"
              v-html="roadmap.brief_description"
            ></div>
          </b-link>
        </app-timeline-item>
      </app-timeline>
    </template>
    <loader :loading="loader" />
  </b-card>
</template>

<script>
import {
  BImg,
  BAvatar,
  BMedia,
  BButton,
  BCollapse,
  VBToggle,
  BListGroup,
  BListGroupItem,
  BAvatarGroup,
  BBadge,
  VBTooltip,
  BLink,
  BSkeleton,
  BCard,
} from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@core/components/loader/Loader.vue";
import Timer from "@core/components/timer/Timer.vue";

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    BImg,
    BMedia,
    BAvatar,
    BButton,
    BCollapse,
    BListGroup,
    BListGroupItem,
    BAvatarGroup,
    BBadge,
    BLink,
    BSkeleton,
    Loader,
    Timer,
    BCard,
  },
  directives: { "b-toggle": VBToggle, "b-tooltip": VBTooltip, Ripple },
  props: {
    semester: {
      type: Object,
      default: () => {},
    },
    roadmaps: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
    finalAmount() {
      let finalAmount = 0;
      if (this.semester.percentage) {
        finalAmount =
          Number(this.semester.amount) -
          (Number(this.semester.amount) * Number(this.semester.rebate)) / 100;
      } else {
        finalAmount =
          Number(this.semester.amount) - Number(this.semester.rebate);
      }

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
  },
  data() {
    return {
      loader: false,
      availableAtTimer: true,
      unavailableAtTimer: true,
    };
  },

  methods: {
    async checkout() {
      if (Object.keys(this.userData).length) {
        this.loader = true;
        try {
          const { data } = await this.$http.post("/panel/invoices", {
            items: [
              {
                model: {
                  id: this.$route.params.id,
                  type: "semester",
                },
              },
            ],
          });
          this.loader = false;

          this.$router.push({
            name: "checkout",
            query: {
              invoice_id: data.data.id,
            },
          });
        } catch (err) {
          this.loader = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: `مشکلی پیش آمده است.`,
                icon: "InfoIcon",
                variant: "danger",
              },
            },
            { position: "bottom-right" }
          );
        }
      } else {
        localStorage.setItem("invoice", this.$route.params.id);
        this.$router.push("/login");
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              duration: 100000,
              title: `لطفا برای خرید دوره وارد حساب کاربری خود شوید`,
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
  },
};
</script>
<style scoped>
.sticky-sidebar {
  position: sticky;
  top: 120px;
}
</style>
